import { Serializable } from '@admin/core/models/serializable';
import { PermissionModel } from '@admin/shared/models/permission-model';

export class AdminUserModel implements Serializable<AdminUserModel> {
  fromObject(object: any): AdminUserModel {
    Object.assign(this, object);

    this.permissions = [];

    if (
      object.permissions &&
      object.permissions.length &&
      object.permissions.length > 0
    ) {
      object.permissions.forEach((el) => {
        let t = new PermissionModel();
        t = t.fromObject(el);
        this.permissions.push(t);
      });
    }

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public adminId: number;
  public fullName: string;
  public email: string;
  public username: string;
  public position: string;
  public permissions: PermissionModel[];
  public dateAdded: Date;

  constructor() {
    this.permissions = [];
  }
}
